import { Component, OnInit } from '@angular/core';

import { LocationService } from '../../../../services/location.service';
import { Location_Inspection } from '../../../../models/location_inspection';
import { PDAUserService } from '../../../../services/pda-user.service';
import { Tablet } from '../../../../models/tablet';
import { JobService } from '../../../../services/rs/job.service';

import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { CompanyService } from '../../../../services/company.service';
import { SnotifyService } from 'ng-snotify';
import { AuthService } from '../../../../services/auth.service';
import { User } from '../../../../models/user';
import { ColourService } from '../../../../services/rs/colour.service';
import { Colour } from '../../../../models/colour';
import { PDAUser } from '../../../../models/pda_User';

@Component({
  selector: 'app-job-manage',
  templateUrl: './job-manage.component.html',
  styleUrls: ['./job-manage.component.css']
})
export class JobManageComponent implements OnInit {
  companies;
  locations;
  locationList;
  fromAmend: boolean;
  isEdit: boolean = false;
  isDay: boolean = true;
  users: PDAUser[];
  colours: Colour[];
  pdaUserId: number = -1;
  job: Location_Inspection;
  user: string;

  constructor(public companyService: CompanyService,
  public locationService: LocationService,
  public pdaUserService: PDAUserService,
  public jobService: JobService,
  public authService: AuthService,
  public colourService: ColourService,
  public router: Router,
  private snotifyService: SnotifyService,
  public route: ActivatedRoute) {
    this.job = new Location_Inspection();
    this.job.scheduled_Date = moment(moment().format("YYYY-MM-DD") + ' ' + "09:00").toDate();
    this.job.scheduled_End_Date = moment(moment().format("YYYY-MM-DD") + ' ' + "17:00").toDate();
    this.job.startTime = moment(moment().format("YYYY-MM-DD") + ' ' + "09:00").toDate();
    this.job.endTime = moment(moment().format("YYYY-MM-DD") + ' ' + "17:00").toDate();
    this.job.fullDay = true;
    this.job.halfDay = false;
    this.job.otherDay = false;
    this.job.colour_ID = 1;

    this.isDay = true;

    this.pdaUserService.getAll().then((data) => {
      this.users = data;
    });

    

  }

  ngOnInit() {
    /*this.companyService.getAll().then((data) => {
      this.companies = data;
      
    });*/

    /*this.locationService.getAll().then((data) => {
      this.locationList = data;


    });*/
    this.colourService.getAll().then((data) => {
      this.colours = data;


    });


    let firstname = this.authService.currentUser.value.firstname.toString();
    let surname = this.authService.currentUser.value.lastname.toString();
    this.user = firstname + " " + surname;
    console.log(this.authService.currentUser.value);
    console.log(this.authService.currentUser.value.userId);
  }

  onCompanyChange(value) {
    this.locations = this.locationList.filter(c => {
      return c.company_Id == value;
    });
  }

  addUser() {
    console.log(this.pdaUserId);
    if (this.pdaUserId == undefined) {
      this.pdaUserId = undefined;
      return;
    }

    let user = this.users.find((u) => {
      return u.pda_User_Id == this.pdaUserId;
    });

    let idx = this.job.users.indexOf(this.job.users.find(a => a.pdaUserId == user.pda_User_Id));
    console.log(idx);
    if (idx > -1) {
      return;
    }
/*    if (this.job.users.length == 0)
      user.isLead = true;

    this.job.users.push(user);
    this.job.engineerIds.push(user.pdaUserId);*/

  }

  removeUser(user) {
    let idx = this.job.users.indexOf(user);
    this.job.users.splice(idx, 1);
    this.job.engineerIds.splice(idx, 1);
  }
  makeUserLead(user) {
    if (!user.isLead) {
      for (var a = 0; a < this.job.users.length; a++) {
        var u = this.job.users[a];
        u.isLead = false;
      }
    }
    user.isLead = !user.isLead;
  }

  dateChange() {
    this.job.scheduled_End_Date = this.job.scheduled_Date;
  }

  halfDay() {
    this.job.startTime = moment(moment().format("YYYY-MM-DD") + ' ' + "09:00").toDate();
    this.job.endTime = moment(moment().format("YYYY-MM-DD") + ' ' + "12:30").toDate();
    this.job.scheduled_End_Date = this.job.scheduled_Date;
    this.job.fullDay = false;
    this.job.halfDay = true;
    this.job.otherDay = false;
    this.isDay = true;
  }
  fullDay() {
    this.job.startTime = moment(moment().format("YYYY-MM-DD") + ' ' + "09:00").toDate();
    this.job.endTime = moment(moment().format("YYYY-MM-DD") + ' ' + "17:00").toDate();
    this.job.scheduled_End_Date = this.job.scheduled_Date;
    this.job.fullDay = true;
    this.job.halfDay = false;
    this.job.otherDay = false;
    this.isDay = true;
  }
  otherDay() {
    this.job.fullDay = false;
    this.job.halfDay = false;
    this.job.otherDay = true;
    this.isDay = false;
  }

  async submit() {
    if (this.job.users.length == 0) {
      alert('Please add at least 1 user');
      return;
    }

    if (this.job.scheduled_End_Date < this.job.scheduled_Date) {
      alert('Please add a end date after the start date');
      return;
    }
    console.log(this.job.users);

    if (this.isEdit) {

    } else {
      var response = await this.jobService.create(this.job.locationId, this.job.job_No, this.job.price, this.job.scheduled_Date, this.job.startTime,
        this.job.scheduled_End_Date, this.job.endTime, this.job.contactName, this.job.contactDetails, this.job.officeContactName, this.job.officeContactDetails,
        this.job.fullDay, this.job.halfDay, this.job.otherDay, this.job.notes, this.job.colour_ID, this.job.purchaseOrder, this.job.job_Type, this.authService.currentUser.value.userId, this.job.users);
      if (response.success) {
        this.snotifyService.success("Successfully created job");
        //this.dialogRef.close(true);
        if (this.fromAmend)
          this.router.navigate(['administration/approval']);
        else
          this.router.navigate(['administration/jobs']);
      } else {
        this.snotifyService.error("Error creating job");

      }
    }
    
  }

  onJobTypeChanged(value) {
    // Get our latest job for this type
    this.jobService.getJobNo(value).then((data) => {
      this.job.job_No = data;
    });
  }

  back() {
    console.log(this.fromAmend);
    if (this.fromAmend) {
      console.log("APPROVAL");
      this.router.navigate(['administration/approval']);
    }
    else {
      console.log("jobs");
      this.router.navigate(['administration/jobs']); 
    }
     
  }

}
